import OperationsQueue from "@/components/ops/OperationsQueue";

export default function ReviewQueue() {
  return <OperationsQueue queueKey="document_review" />;
}
